import "./App.css";
import { Routes, Route } from "react-router-dom";
import { createAxiosResponseInterceptor } from "./api/interceptor";
import ProtectedRoute from "./routes/ProtectedRoute";
import GuestRoute from "./routes/GuestRoute";

// Layouts
import AuthLayout from "./layouts/AuthLayout";
import MainLayout from "./layouts/MainLayout";

// Pages
import LoginPage from "./Components/LoginPage/LoginPage";
import GenerateOtp from "./Components/GenerateOtp/GenerateOtp";
import Register from "./Components/Registration/Registration";
import Dashboard from "./Components/Dashboard/dashboard";
import Profile from "./Components/Profile/Profile";
import Notification from "./Components/Notification.js/Notification";
import SellScreen from "./Components/Sell/SellScreen";
import SellHistoryScreen from "./Components/Sell/SellHistory";
import GiftScreen from "./Components/Gifts/gifts";
import GiftHistoryScreen from "./Components/Gifts/GiftHistory";
import RedeemHistoryScreen from "./Components/Redeem/RedeemHistoryScreen";
import CreateRedeemOrder from "./Components/Redeem/CreateRedeemOrder";
import PendingRedeemScreen from "./Components/Redeem/PendingRedeemScreen";
import SavingsScreen from "./Components/SavingsScreen/SavingsScreen";
import PassbookScreen from "./Components/Passbook/passbook";
import CustomerSipScreen from "./Components/Sip/CustomerSipScreen";
import AllSipScreen from "./Components/Sip/AllSipScreen";
import OrderSummary from "./Components/OrderSummaryScreen/OrderSummaryScreen";
import PaymentStatusScreen from "./Components/PaymentStatusScreen/paymentStatusScreen";
import OfflinePaymentScreen from "./Components/OfflinePaymentScreen/offlinePaymentScreen";
import DiamondPointsScreen from "./Components/DiamondPoints/DiamondPointsScreen ";
import DiamondPointPendingOrder from "./Components/DiamondPoints/DiamondPointPendingOrder";
import SIPSummary from "./Components/Sip/SipSummaryScreen";
import OfflineSIPPaymentScreen from "./Components/Sip/OfflineSipPaymentScreen";
import InstallmentScreen from "./Components/Sip/InstallmentScreen";
import ProductView from "./Components/Product/ProductView";
import ProductOrder from "./Components/Product/ProductOrder/ProductOrder";
import ProductDetailsPage from "./Components/Product/ProductDetails/ProductDetails";
import ProductPriceCalculator from "./Components/Product/ProductPriceCalculator/ProductPriceCalculator";
import ProductOrderDetails from "./Components/Product/ProductOrder/ProductOrderDetails";
import PaymentVerify from "./Components/OrderSummaryScreen/PaymentVerify";
import SIPCalculator from "./Components/Sip/SIPCalculator";
import Content from "./Components/Profile/Content";
import CommonWebView from "./Components/Common/CommonWebView";
import DepositScreen from "./Components/DepositPlan/DepositPlanScreen";
import AllDepositPlanScreen from "./Components/DepositPlan/AllDepositPlanScreen";
import BullionDepositeHistory from "./Components/DepositPlan/DepositPlanHistory";
import DepositDetails from "./Components/DepositPlan/DepositDetails";
import ExploreScreen from "./Components/Explore/ExploreTabScreen"
import VipMembershipPage from "./Components/VipCustomer/VipMembershipPage";
import OfflineTransactionsScreen from "./Components/OfflineTransaction/OfflineTransactionPage";
import JewelleryView from "./Components/Jewellery/JewelleryView";
import JewelleryDetails from "./Components/Jewellery/JewelleryDetails";
import JewelleryOrder from "./Components/Jewellery/JewelleryOrder";
import JewelleryOrderDetails from "./Components/Jewellery/JewelleryOrderDetails";
import JewelleryCart from "./Components/Jewellery/JewelleryCart";

function App() {
  createAxiosResponseInterceptor();

  return (
    <Routes>
      {/* PayG returns to /webhookUrl after payment (same as mobile WebView). */}
      <Route path="/webhookUrl" element={<PaymentVerify />} />
      <Route path="/PaymentVerify" element={<PaymentVerify />} />

      {/* Public / Auth Routes */}
      <Route element={<AuthLayout />}>
        <Route
          path="/"
          element={
            <GuestRoute>
              <LoginPage />
            </GuestRoute>
          }
        />
        <Route
          path="/login"
          element={
            <GuestRoute>
              <LoginPage />
            </GuestRoute>
          }
        />
        <Route
          path="/GenerateOtp"
          element={
            <GuestRoute>
              <GenerateOtp />
            </GuestRoute>
          }
        />
        <Route
          path="/Register"
          element={
            <GuestRoute>
              <Register />
            </GuestRoute>
          }
        />
      </Route>

      {/* Protected / Dashboard Routes */}
      <Route element={<MainLayout />}>
        <Route
          path="/Dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/Profile"
          element={
            <ProtectedRoute>
              <Profile />
            </ProtectedRoute>
          }
        />
        <Route
          path="/Notification"
          element={
            <ProtectedRoute>
              <Notification />
            </ProtectedRoute>
          }
        />
        <Route path="Sell" element={<SellScreen />} />
        <Route path="SellHistory" element={<SellHistoryScreen />} />
        <Route path="Gifts" element={<GiftScreen />} />
        <Route path="GiftHistory" element={<GiftHistoryScreen />} />
        <Route
          path="/RedeemHistory"
          element={
            <ProtectedRoute>
              <RedeemHistoryScreen />
            </ProtectedRoute>
          }
        />
        <Route
          path="/redeem"
          element={
            <ProtectedRoute>
              <CreateRedeemOrder />
            </ProtectedRoute>
          }
        />
        <Route
          path="/PendingRedeemScreen"
          element={
            <ProtectedRoute>
              <PendingRedeemScreen />
            </ProtectedRoute>
          }
        />
        <Route
          path="/SavingsScreen"
          element={
            <ProtectedRoute>
              <SavingsScreen />
            </ProtectedRoute>
          }
        />
        <Route
          path="/PassbookScreen"
          element={
            <ProtectedRoute>
              <PassbookScreen />
            </ProtectedRoute>
          }
        />
        <Route
          path="/CustomerSipScreen"
          element={
            <ProtectedRoute>
              <CustomerSipScreen />
            </ProtectedRoute>
          }
        />
        <Route
          path="/AllSipScreen"
          element={
            <ProtectedRoute>
              <AllSipScreen />
            </ProtectedRoute>
          }
        />
        <Route
          path="/OrderSummary"
          element={
            // <ProtectedRoute>
            <OrderSummary />
            // </ProtectedRoute>
          }
        />
        <Route
          path="/payment-status"
          element={
            <ProtectedRoute>
              <PaymentStatusScreen />
            </ProtectedRoute>
          }
        />
        <Route
          path="/offline-payment"
          element={
            <ProtectedRoute>
              <OfflinePaymentScreen />
            </ProtectedRoute>
          }
        />
        <Route
          path="/DiamondPoints"
          element={
            <ProtectedRoute>
              <DiamondPointsScreen />
            </ProtectedRoute>
          }
        />
        <Route
          path="/DiamondPointPendingOrder"
          element={
            <ProtectedRoute>
              <DiamondPointPendingOrder />
            </ProtectedRoute>
          }
        />
        <Route
          path="/SipSummary"
          element={
            <ProtectedRoute>
              <SIPSummary />
            </ProtectedRoute>
          }
        />
        <Route
          path="/offlineSipPayment"
          element={
            <ProtectedRoute>
              <OfflineSIPPaymentScreen />
            </ProtectedRoute>
          }
        />
        <Route
          path="/installmentScreen"
          element={
            <ProtectedRoute>
              <InstallmentScreen />
            </ProtectedRoute>
          }
        />
        <Route
          path="/productView"
          element={
            <ProtectedRoute>
              <ProductView />
            </ProtectedRoute>
          }
        />
        <Route
          path="/productOrder"
          element={
            <ProtectedRoute>
              <ProductOrder />
            </ProtectedRoute>
          }
        />
        <Route
          path="/productDetails"
          element={
            <ProtectedRoute>
              <ProductDetailsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/productPriceCalculator"
          element={
            <ProtectedRoute>
              <ProductPriceCalculator />
            </ProtectedRoute>
          }
        />
        <Route
          path="/productOrderDetails"
          element={
            <ProtectedRoute>
              <ProductOrderDetails />
            </ProtectedRoute>
          }
        />
        <Route
          path="/artificialJewellery"
          element={
            <ProtectedRoute>
              <JewelleryView />
            </ProtectedRoute>
          }
        />
        <Route
          path="/artificialJewelleryDetails"
          element={
            <ProtectedRoute>
              <JewelleryDetails />
            </ProtectedRoute>
          }
        />
        <Route
          path="/artificialJewelleryCart"
          element={
            <ProtectedRoute>
              <JewelleryCart />
            </ProtectedRoute>
          }
        />
        <Route
          path="/artificialJewelleryOrder"
          element={
            <ProtectedRoute>
              <JewelleryOrder />
            </ProtectedRoute>
          }
        />
        <Route
          path="/artificialJewelleryOrderDetails"
          element={
            <ProtectedRoute>
              <JewelleryOrderDetails />
            </ProtectedRoute>
          }
        />
        <Route
          path="/artificialJewelleryOfflinePayment"
          element={
            <ProtectedRoute>
              <OfflinePaymentScreen />
            </ProtectedRoute>
          }
        />
        <Route
          path="/SIPCalculator"
          element={
            <ProtectedRoute>
              <SIPCalculator />
            </ProtectedRoute>
          }
        />
        <Route
          path="/Content"
          element={
            <ProtectedRoute>
              <Content />
            </ProtectedRoute>
          }
        />
        <Route
          path="/webview"
          element={
            <ProtectedRoute>
              <CommonWebView />
            </ProtectedRoute>
          }
        />
        <Route
          path="/allDepositPlan"
          element={
            <ProtectedRoute>
              <AllDepositPlanScreen />
            </ProtectedRoute>
          }
        />
        <Route
          path="/depositPlan"
          element={
            <ProtectedRoute>
              <DepositScreen />
            </ProtectedRoute>
          }
        />
        <Route
          path="/depositPlanHistory"
          element={
            <ProtectedRoute>
              <BullionDepositeHistory />
            </ProtectedRoute>
          }
        />
        <Route
          path="/depositDetails"
          element={
            <ProtectedRoute>
              <DepositDetails />
            </ProtectedRoute>
          }
          />
          <Route 
          path = "/explore"
          element={
            <ProtectedRoute>
              <ExploreScreen />
            </ProtectedRoute>
          }
          />
        <Route
          path="/vipMembership"
          element={
            <ProtectedRoute>
              <VipMembershipPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/OfflineTransactions"
          element={
            <ProtectedRoute>
              <OfflineTransactionsScreen />
            </ProtectedRoute>
          }
        />
      </Route>
    </Routes>
  );
}

export default App;
